// Normalizadores compartilhados entre páginas — só entram aqui os mapeamentos que são
// idênticos em mais de uma tela. Normalização específica de uma entidade continua na
// própria página (ex.: normalizeContato de ContatosPage usa outro shape).

// Reduz um contato a { id, nome } para uso nos selects de contato (obra/empresa).
export function normalizeContatoOption(item) {
  return {
    id: String(item.id || item.idContato || item.id_contato || ''),
    nome: item.nome || item.nomeCompleto || '-',
  };
}

// Extrai um array de respostas que podem vir como lista direta, {data} ou {items}.
export function asArray(value) {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.items)) return value.items;
  return [];
}

// Normaliza uma empresa da API (snake/camel, cidade e contatos aninhados) para o formato da tela.
export function normalizeEmpresa(item) {
  if (!item || typeof item !== 'object') return null;

  const cidade = item.cidade || item.cidadeDTO || item.cidadeResponse || null;
  const contatoTecnico = item.contatoTecnico || item.contato_tecnico || null;
  const contatoFinanceiro = item.contatoFinanceiro || item.contato_financeiro || null;
  const contatoAdministrativo = item.contatoAdministrativo || item.contato_administrativo || null;
  const usuarioAssinatura1 = item.usuarioAssinatura1 || item.usuario_assinatura_1 || null;
  const usuarioAssinatura2 = item.usuarioAssinatura2 || item.usuario_assinatura_2 || null;

  // Mantem um formato interno unico para evitar quebra quando backend alterna snake/camel.
  return {
    idEmpresa: String(item.id_empresa || item.idEmpresa || item.id || ''),
    idCliente: String(item.id_cliente || item.idCliente || item.cliente?.id_cliente || item.cliente?.idCliente || item.cliente?.id || ''),
    razaoSocial: item.razao_social || item.razaoSocial || item.nome_fantasia || item.nomeFantasia || item.nome || '-',
    numrCnpj: String(item.numr_cnpj || item.numrCnpj || item.cnpj || ''),
    numrCpf: String(item.numr_cpf || item.numrCpf || item.cpf || ''),
    endereco: item.endereco || '',
    codgCep: String(item.codg_cep || item.codgCep || item.cep || ''),
    idCidade: String(item.id_cidade || item.idCidade || cidade?.idCidade || cidade?.id_cidade || cidade?.id || ''),
    nomeCidade: item.nome_cidade || item.nomeCidade || cidade?.nomeCidade || cidade?.nome || '',
    uf: String(item.uf || item.UF || cidade?.siglaUf || cidade?.uf || cidade?.UF || ''),
    idUsuarioTecnico: String(item.id_usuario_tecnico || item.idContatoTecnico || contatoTecnico?.idContato || contatoTecnico?.id_contato || contatoTecnico?.id || ''),
    idUsuarioFinanceiro: String(item.id_usuario_financeiro || item.idContatoFinanceiro || contatoFinanceiro?.idContato || contatoFinanceiro?.id_contato || contatoFinanceiro?.id || ''),
    idUsuarioAdministrativo: String(item.id_usuario_administrativo || item.idContatoAdministrativo || contatoAdministrativo?.idContato || contatoAdministrativo?.id_contato || contatoAdministrativo?.id || ''),
    idUsuarioAssinatura1: String(item.id_usuario_assinatura_1 || item.idUsuarioAssinatura1 || usuarioAssinatura1?.idUsuario || ''),
    idUsuarioAssinatura2: String(item.id_usuario_assinatura_2 || item.idUsuarioAssinatura2 || usuarioAssinatura2?.idUsuario || ''),
    criadoEm: item.criado_em || item.criadoEm || item.createdAt || null,
  };
}

// Normaliza um contato da API para o formato usado nas telas de obra e empresa.
export function normalizeContato(item) {
  if (!item || typeof item !== 'object') return null;

  // Mantem a lista alinhada com a tela global de contatos.
  return {
    id: String(item.id || item.id_contato || item.idContato),
    idCliente: String(item.id_cliente || item.idCliente || ''),
    nome: item.nome || item.nome_contato || item.nomeCompleto || '-',
    numrCpf: String(item.numr_cpf || item.numrCpf || item.cpf || ''),
    telefone: String(item.telefone || item.numr_telefone || item.numrTelefone || ''),
    enderecoEmail: item.enderecoEmail || item.endereco_email || item.email || '',
  };
}
